<template>
  <li
    v-if="isMenuItem"
    class="nav-item"
    @click="openConnectBankWidget"
  >
    <span class="menu-label">Conectar minha conta</span>
    <img
      src="../../assets/open_finance.png"
      class="mt-2"
      height="20px"
    >
  </li>
  <div
    v-else
    class="col-auto row"
  >
    <img
      src="../../assets/open_finance.png"
      class="col-auto"
      height="40px"
    >
    <button
      class="btn-default-bigger no-width col-auto px-3"
      :disabled="loadingConnectToken"
      @click="openConnectBankWidget"
    >
      <i class="fa-solid fa-plus" />
      <span>{{
        loadingConnectToken ? "Conectando..." : "Conectar com meu banco"
      }}</span>
    </button>
  </div>
</template>

<script>
import AccountBox from "../bank_account/AccountBox.vue";
import Modal from "../shared/Modal.vue";
import AccountDetail from "../bank_account/AccountDetail.vue";
import FormAccount from "../bank_account/FormAccount.vue";
import { useAppStore } from "@/store/store.js";
import { useOpenFinanceStore } from "@/store/open_finance/store.js";
import FormEditAccount from "../bank_account/FormEditAccount.vue";
import { useConfirm } from "primevue/useconfirm";

export default {
  components: {
    AccountBox,
    Modal,
    FormAccount,
    AccountDetail,
    FormEditAccount,
  },
  props: {
    isMenuItem: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { confirm: useConfirm() };
  },
  data() {
    return {
      loadingConnectToken: false,
      accountConnected: false,
    };
  },
  computed: {
    isSubscriber() {
      const store = useAppStore();
      return store.isSubscriberAccess() || false;
    },
  },
  methods: {
    loadPluggyScript() {
      return new Promise((resolve, reject) => {
        if (this.pluggyScriptLoaded || window.PluggyConnect) {
          this.pluggyScriptLoaded = true;
          return resolve();
        }
        const script = document.createElement("script");
        script.src =
          process.env.VUE_APP_PLUGGY_SCRIPT_URL ||
          "https://cdn.pluggy.ai/pluggy-connect/v2.8.2/pluggy-connect.js";
        script.onload = () => {
          this.pluggyScriptLoaded = true;
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async openConnectBankWidget() {
      if (!this.isSubscriber) {
        this.confirm.require({
          message:
            "A conexão com instituições bancárias está disponível apenas para assinantes.",
          header: "Acesso premium",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Quero assinar",
          rejectLabel: "Voltar",
          accept: () => {
            this.$router.push({ name: "checkout" });
          },
        });
      } else {
        this.loadingConnectToken = true;
        const openFinanceStore = useOpenFinanceStore();
        openFinanceStore
          .getConnectToken()
          .then(async (response) => {
            if (response.data?.accessToken) {
              await this.openPluggyWidget(response.data.accessToken);
            }
          })
          .catch((error) => {
            this.showPluggyConnectError(error);
          });
      }
    },
    async openPluggyWidget(token) {
      try {
        await this.loadPluggyScript();
        const pluggyConnect = new window.PluggyConnect({
          connectToken: token,
          includeSandbox: process.env.VUE_APP_PLUGGY_SANDBOX_MODE === "true",
          onSuccess: (itemData) => {
            const { id, connector } = itemData?.item || {};
            if (
              id &&
              connector?.id &&
              connector?.name &&
              connector?.imageUrl &&
              connector?.products
            ) {
              const openFinanceStore = useOpenFinanceStore();
              const appStore = useAppStore();
              openFinanceStore
                .saveAccount({
                  itemId: id,
                  id: connector.id,
                  name: connector.name,
                  logo: connector.imageUrl,
                  products: connector.products,
                })
                .then(async (response) => {
                  appStore.getAccounts();
                  this.loadingConnectToken = false;
                  this.accountConnected = true;
                })
                .catch((error) => {
                  console.error("Pluggy Connect Error (saveAccount):", error);
                  this.showPluggyConnectError("Não foi possível salvar a conta Open Finance conectada.");
                });
            }
          },
          onClose: () => {
            this.loadingConnectToken = false;
            if (this.accountConnected) {
              this.$router.push({
                name: "settings",
              });
              this.accountConnected = false;
            }
          },
          onError: (error) => {
            console.error("Pluggy Connect Error (onError):", error);
            this.showPluggyConnectError("Ocorreu um erro ao conectar com o Open Finance.");
          },
        });
        pluggyConnect.init();
      } catch (error) {
        console.error("Pluggy Connect Error (try-catch):", error);
        this.showPluggyConnectError("Não foi possível carregar o widget de conexão com o Open Finance.");
      }
    },
    showPluggyConnectError(error) {
      this.loadingConnectToken = false;
      this.$toast.add({
        severity: "error",
        summary: "Erro",
        detail: error,
      });
    },
  },
};
</script>

<style scoped>
.nav-item {
  width: 100%;
  cursor: pointer;
  border: #cb5540 1px solid;
  border-radius: 4px;
  color: #ffffff;
  margin-top: 10px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.nav-item:hover {
  background: #cb5540 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 10px #f26236ad;
  border-radius: 4px;
  opacity: 0.97;
}
</style>
